import styled from 'styled-components'

interface Props {
  flexDirection?: string
}

export const FieldContainer = styled.div<Props>`
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: ${props => (props.flexDirection ? props.flexDirection : 'column')};
  padding: 0 0 0 0;
`
